// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmModal_container__2EWfl","title":"ConfirmModal_title__3y1ZU","content":"ConfirmModal_content__35qOv","buttons":"ConfirmModal_buttons__2H2_b"};